import { getSecureItem } from "@/Utils/SecureStorage";

function isAuthenticated() {
  return !!getSecureItem("qr-token");
}

export function RouteGuard(to, from, next) {
  const publicRoutes = [
    "/login",
  ];

  if (isAuthenticated()) {
    if (publicRoutes.includes(to.path)) {
      if (getSecureItem("role") === "QrReader") {
        return next("/reader-home");
      }
    }
    return next();
  } else {
    if (publicRoutes.includes(to.path)) {
      return next();
    }
    return next("/login");
  }
}
